/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React from 'react';
import { FlagsBoundary } from '@jira/platform__flags-boundary/src/FlagsBoundary.tsx';
import { type AsyncFlagProps, CommonFlag } from '../index.tsx';

const AkFlag = ({ packageName = 'flags', ...props }: AsyncFlagProps): React.JSX.Element => (
	<FlagsBoundary packageName={packageName}>
		<CommonFlag flagType="info" {...props} />
	</FlagsBoundary>
);

export default AkFlag;
